import React, { useEffect } from "react";
import OrientationLocker from "./components/orientationLocker";
import RouteChangeTracker from "./components/routeChangeTracker";
import Content from "./route";
import { useLocation } from "react-router-dom";
import useAuthStore from "./store/useAuthStore";
import useFilterStore from "./store/useFilterStore";
import useTableStore from "./store/useTabStore";
import useTemplateStore from "./store/useTemplateStore";
import Footer from "./components/ui/Footer";

const App: React.FC = () => {
  const { fetchFilterData } = useFilterStore();
  const { fetchColumns } = useTableStore();
  const { fetchTemplateData } = useTemplateStore();
  const hydrateAuth = useAuthStore((s) => s.hydrate);
  const location = useLocation();
  const hideGlobalFooter = location.pathname.startsWith("/search") || location.pathname === "/";

  useEffect(() => {
    hydrateAuth();
  }, [hydrateAuth]);

  useEffect(() => {
    fetchFilterData();
    fetchColumns();
    fetchTemplateData();
  }, [fetchFilterData, fetchColumns, fetchTemplateData]);

  useEffect(() => {
    const oldStorageKey = "lnp-template-storage";
    try {
      const item = localStorage.getItem(oldStorageKey);
      if (item) {
        localStorage.removeItem(oldStorageKey);
      }
    } catch (error) {
      console.error(
        `Error removing old data ('${oldStorageKey}') from localStorage:`,
        error
      );
    }
  }, []);

  return (
    <div className="flex flex-col w-full min-h-screen">
      <OrientationLocker />
      <RouteChangeTracker />
      <div className="flex-1 w-full flex flex-col">
        <Content />
      </div>
      {!hideGlobalFooter && <Footer />}
    </div>
  );
};

export default App;
